import Printer from './Printer'

export default Printer
